import Vue from "vue";
import { Component } from "vue-property-decorator";
import { ActiviteDto } from "../../../../dto/GenApi.iNotPaie.Dto/ActiviteDto";
import { ServicesFactoryInstance } from "../../../Controls/ServicesFactory";
import ModalCardActivity from "../../modals/modalCardActivity/modalCardActivity";
import $ from "jquery";
import { EventBus } from "../../../Controls/EventBus";
import { ModalAlerteOptions } from "../../../modalComponents/modalAlerte/modalAlerte";
import EventConstants from "../../../Controls/EventConstants";
import { NotificationServiceInstance } from "../../../../shared/services/notification.service";

@Component({
	components: {
		ModalCardActivity: require("../../modals/modalCardActivity/modalCardActivity.vue.html")
	}
})
export default class CardActivityComponent extends Vue {
	public dataReady = false;
	public activites: ActiviteDto[] = [];
	public showAllEnable = false;

	public mounted(): void {
		this.loadData();
	}


	public showAll(): void {
		this.showAllEnable = !this.showAllEnable;
		this.loadData();
	}

	public loadData(): void {
		this.dataReady = false;
		ServicesFactoryInstance.AccueilService.getActivites(this.showAllEnable, data => {
			this.activites = data;
			this.dataReady = true;
		}, () => {
			this.dataReady = true;
		});
	}

	public addActivity(): void {
		const modalAjoutEditPersonnes = this.$refs.modalCardActivity as ModalCardActivity;
		modalAjoutEditPersonnes.init(true);
		$("#modalCardActivity").modal("show");
	}

	public viewActivity(activite: ActiviteDto, isEdit: boolean): void {
		const modalActivite = this.$refs.modalCardActivity as ModalCardActivity;
		$("#modalCardActivity").modal("show");

		modalActivite.init(isEdit, activite);
	}

	public deleteActivity(activite: ActiviteDto): void {
		const modalOptions: ModalAlerteOptions = new ModalAlerteOptions({
			message: "Souhaitez-vous vraiment supprimer cette note ?",
			callBackYes: () => {
				this.deleteActivityYes(activite);
			}
		});
		EventBus.$emit(EventConstants.MODAL_ALERT, modalOptions);
	}

	public deleteActivityYes(activite: ActiviteDto): void {
		this.dataReady = false;

		ServicesFactoryInstance.AccueilService.deleteActivite(activite, () => {
			this.dataReady = true;
			NotificationServiceInstance.SendSuccess("La note a bien été supprimée.");
			this.loadData();
		}, () => {
			NotificationServiceInstance.SendFailed("Erreur lors de la suppresion de la note.");
			this.dataReady = true;
		});
	}

	public refresh(): void {
		this.loadData();
	}
}



// WEBPACK FOOTER //
// ./src/components/home/cards/cardActivity/cardActivity.ts